import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { handleAvatarMerge, parseNames } from '../utils/messenger_utils';
import { NEW_MESSAGE } from '../reducers/messenger_reducers';

const WindowComponent = ({ id, header, orderedNames, avatars, positionRight, children, close }) => {
  const [showSelf, setShowSelf] = useState(true);

  const handleAvatars = avatars => {
    if (avatars.length === 1) {
      return (
        <div className="display-flex">
          <img src={avatars[0]} className="avatar sm header" />
          <p className="h5 w3 message-card-name open-window">{parseNames(orderedNames)}</p>
        </div>
      )
    } else {
      return (
        <div className="display-flex">
          <div className="avatar-group-container header" >
            {handleAvatarMerge(avatars)}
          </div>
          <p className="h5 w3 message-card-name open-window">{parseNames(orderedNames)}</p>
        </div>
      )
    }
  }

  const handleHeader = () => {
    if (header === NEW_MESSAGE) {
      return <p className="h5 w3">{header}</p>
    }
    return handleAvatars(avatars)
  };

  return (
    <div
      className={`module messenger-window wrapper short ${!showSelf ? 'shrink' : ''
        }`}
      style={{ right: `${positionRight}rem` }}
    >
      <div
        className='module-header display-flex justify-between align-center mb-15 pointer'
        onClick={() => setShowSelf(!showSelf)}
      >
        {handleHeader()}
        <i
          className="fa fa-times pointer icon convo"
          onClick={(e) => close(e, id)}
        />
      </div>
      {children}
    </div>
  );
}

WindowComponent.propTypes = {
  id: PropTypes.string,
  header: PropTypes.oneOf([null, NEW_MESSAGE]),
  orderedNames: PropTypes.array,
  avatars: PropTypes.array,
  positionRight: PropTypes.number,
  children: PropTypes.element,
  close: PropTypes.func
};

export default WindowComponent;
